/**
 * This file contains tools aimed at product owners in order to simplify certain tasks
 * such as creation of onboarding flows using 3rd party tools
 */

const pause = async (time: number) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

const POTools = {
  /**
   * Return a data-automation CSS-selector
   *
   * @param dataAutomation
   */
  da: (dataAutomation: string) => {
    return `[data-automation=${dataAutomation}]`
  },
  /**
   * Clicks any number selectors in order and will wait for them to appear before clicking
   * Multiple options can be provided for each step, first option to be encountered will be clicked
   *
   * @example PO.click([PO.da('payment-means-button'), PO.da('mainmenu-settings')], PO.da('paymentMethods-btn'));
   * @param steps
   */
  click: async (...steps: string[] | string[][]) => {
    try {
      let times = 10
      for (let targets of steps) {
        if (typeof targets === 'string') {
          targets = [targets]
        }

        let clicked = false
        while (!clicked) {
          for (const target of targets) {
            const element = document.querySelector(target)
            if (element) {
              ;(element as HTMLElement).click()
              clicked = true
              break
            }
          }
          if (!clicked) {
            await pause(300)
            if (--times < 0) {
              return
            }
          } else {
            times = 10
          }
        }
      }
    } catch (e) {
      console.error(e)
    }
  },
}

// @ts-ignore
window.PO = POTools
